<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:zipFlag="true"
		:reportName="reportName"
		:detailType="detailType"
		:getFiltersParams="getFiltersParams"
		:getCustomThroughParams="getCustomThroughParams"
		@clearSearchClick='clearSearchClick'
		:reportFormUrl="reportFormUrl">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/orderCustomDetail.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrapNew.vue'
import FiltersBox from '@/components/reportform/goodCustomDetail/FiltersBox.vue'
export default {
	name: 'orderCustomDetail',
	components: {
		reportFormWrap,
		FiltersBox
	},
	data () {
		return {
			reportid: 'REPORT_DHKHMX_000001',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/getProductSaleCustomerReport`,
			orderMenu: orderMenu,
			reportName: 'orderCustomDetail',
			detailType: 'order'
		}
	},
	mounted () {
		// console.log(this.$route.query)
		if (this.$route.query.target === 'unorder') {
			this.reportFormUrl = `${this.$fxBaseApi.urlReport}/report/getProductSaleUnCustomerReport`
			this.detailType = 'unorder'
		}
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
